import { render } from "./leave-policies.vue?vue&type=template&id=5a75f376&scoped=true"
import script from "./leave-policies.vue?vue&type=script&lang=js"
export * from "./leave-policies.vue?vue&type=script&lang=js"

import "./leave-policies.vue?vue&type=style&index=0&id=5a75f376&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a75f376"]])

export default __exports__